export const env = {
    // baseUrl: 'http://192.168.15.51:2000/api/juma/v0/',       // devs
    // baseUrl: 'http://192.168.15.51/api/juma/v0/',       // devs
    // imgUrl: 'http://192.168.15.51/api/juma/v0/images/', // dev
    baseUrl: 'https://salom.alif.tj/api/newsalom/v0/',       // prod
    imgUrl: 'https://salom.alif.tj/api/newsalom/v0/images/', // prod
};
